<div class="card type-process">
    <p class="card-title">Que tipo de cadastro você deseja criar?</p>


    <div class="type-process-item" *ngFor="let item of typePolices">
        <div class="dropdown" >
            <button class="btn btn-secondary dropdown-toggle" (click)="getPolicy(item.id)" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{item.name}}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <ul>
                    <li *ngFor="let policy of policies">
                        <a href="javascript:;" *ngIf="validateAccessPolicy(policy)" (click)="selectPolicy(policy.id)">{{policy.name}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</div>